import request from '@/utils/request'

export async function getData(data) {
  return request({
    url: '/personApplications/all/history/list',
    method: 'post',
    data,
  })
}
export async function getDetail(data) {
  return request({
    url: '/personApplications/history/detail',
    method: 'get',
    params: data,
  })
}
export async function returnPerson(data) {
  return request({
    url: '/personApplications/return',
    method: 'post',
    data,
  })
}
export async function returnSubmit(data) {
  return request({
    url: '/personApplications/returnSubmit',
    method: 'post',
    data,
  })
}